import Cookies from 'js-cookie';

export const setCookie = (
  key: string, 
  value: string, 
  options?: {
    expires?: number | Date | undefined;
    path?: string;
    secure?: boolean;
  }
) => {
  Cookies.set(key, value, {
    expires: options?.expires || 7, // 7 days default
    path: options?.path || '/',
    secure: options?.secure || false
  });
};

export const getCookie = (key: string) => {
  return Cookies.get(key);
};

export const removeCookie = (key: string) => {
  Cookies.remove(key);
};